import { GetBondsBondParams } from '@goldwasserexchange/actor/rest-services';
import { createContext } from 'react';

export const bondsBondParamsContext = createContext<Partial<GetBondsBondParams>>({});
